<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="false"
    ></b-loading>
    <on-board-top-navbar />
    <section class="section">
      <document-previewer
        v-if="documentUrl"
        :documentTitle="$t(`Borrador de ${documentType}`)"
        :documentUrl="documentUrl"
      />
      <vue-fab size="big" icon="play_arrow" mainBtnColor="#de4282">
        <fab-item
          @clickItem="callPostRespondOnboardReviewRequest('accepted')"
          :idx="0"
          color="#409644"
          :title="$t('Aceptar')"
          icon="done"
        />
        <fab-item
          @clickItem="callPostRespondOnboardReviewRequest('declined')"
          :idx="1"
          color="#e87e3c"
          :title="$t('Solicitar información')"
          icon="help"
        />
      </vue-fab>
    </section>
  </div>
</template>

<script>
import OnBoardTopNavbar from '@/components/on-board/OnBoardTopNavbar'
import DocumentPreviewer from '@/components/on-board/DocumentPreviewer'
import NotificationModal from '@/components/on-board/NotificationModal'
import { mapActions } from 'vuex'
import Fetcher from '@/mixins/fetcher.js'

export default {
  props: {
    id: {
      type: String,
      required: true
    },
    documentType: {
      type: String,
      required: true
    }
  },
  mixins: [Fetcher],
  components: {
    DocumentPreviewer,
    OnBoardTopNavbar
  },
  data: () => ({
    activeTab: 0,
    documentUrl: '',
    documents: {}
  }),
  methods: {
    ...mapActions('onBoard', [
      'getOnboardRequestInfo',
      'postRespondOnboardReviewRequest',
      'putUpdateOnboardRequest'
    ]),
    setOnboardRequestInfo(data) {
      const toCamel = s => {
        return s.replace(/([-_][a-z])/gi, $1 => {
          return $1
            .toUpperCase()
            .replace('-', '')
            .replace('_', '')
        })
      }

      let self = this
      const kamelData = this.keysToCamel(data)
      self.documents = kamelData['documents']
      self.documentUrl = self.documents[toCamel(self.documentType)].url
    },
    callGetOnboardRequestInfo() {
      let self = this
      self.request(() =>
        self.getOnboardRequestInfo(self.id).then(function(response) {
          self.setOnboardRequestInfo(response.data)
        })
      )
    },
    showModal: function() {
      let self = this
      self.$dlg.modal(NotificationModal, {
        shaking: false,
        title: false,
        params: {
          title: self.$t('Estimado solicitante'),
          bgColor: '#de4281',
          content: `
                  <div style="text-align: left;">
                  <p>${self.$t('Leer atentamente')}:</p>
                  <br>
                  <p>${self.$t('PROPOSAL_PREVIEW_1')}.</p>
                  <p>${self.$t('PROPOSAL_PREVIEW_2')}​.</p>
                  
                   <br>
                  <p>${self.$t('PROPOSAL_PREVIEW_3')}.</p>
                   <br>
                  <p>${self.$t('The Team')}​</p></div>
                  `,
          confirmText: this.$t('Aceptar'),
          closeText: this.$t('Cerrar')
        },
        callback: () => {
          self.$router.push({
            name: 'onBoard.neofintech.myNeofintechRequestDetail',
            params: { id: self.id }
          })
        }
      })
    },
    callPostRespondOnboardReviewRequest(response) {
      let self = this
      self.request(() =>
        self
          .postRespondOnboardReviewRequest({
            requestId: self.id,
            data: { documentType: self.documentType, response }
          })
          .then(function() {
            if (response == 'accepted') {
              self
                .putUpdateOnboardRequest({
                  data: {
                    status: `P3-${self.documentType.toUpperCase()}-ACCEPTED`
                  },
                  requestId: self.id
                })
                .then(() => {
                  self.showModal()
                })
            } else {
              self
                .putUpdateOnboardRequest({
                  data: {
                    status: `P3-${self.documentType.toUpperCase()}-REJECTED`
                  },
                  requestId: self.id
                })
                .then(() => {
                  window.open(
                    'https://myneofintech.com/myneofintech/conference/',
                    '_blank'
                  )
                })
            }
          })
      )
    }
  },
  beforeMount() {
    this.callGetOnboardRequestInfo()
  },
  mounted() {
    this.$store.commit('layout/FULL_PAGE', true)
  },
  beforeDestroy() {
    this.$store.commit('layout/FULL_PAGE', false)
  }
}
</script>

<style>
#app {
  overflow: scroll !important;
}

.fab-main-container {
  bottom: 6% !important;
}
</style>
